function onlyNumbers (value) {
  if (typeof (value) === 'string') {
    return value.replace(/[^\d]+/g, '')
  }

  return value
}

export { onlyNumbers }
